import React from 'react'

export default function FooterAbout() {
    return (
        <div className="col-sm-3">
            <div className="widget">
                <h5 className="widget-title font-alt">About Victoria</h5>
                <p>Victoria is a car service center that uses simulation technologies to visualize all your customizations before implementing them.</p>
                <p>Email:   <a href="#">reza.torkashvand.ins@gmail.com</a></p>
            </div>
        </div>
    )
}
